import React, {useEffect, useState} from 'react'
import {
  getConfigurationByName,
  updateConfigurationByConfigID,
} from '../../../../../../API/api-endpoint'
import ToastUtils, {ErrorToastUtils} from '../../../../../../utils/ToastUtils'

const WithDrawalPlugin = () => {
  const [configID, setConfigId] = useState(0)
  const [withdrawalConfig, setWithdrawalConfig] = useState<any>({
    isWithdraw: false,
    withDrawMinLimit: 0,
    withDrawDiamonds: 1000,
    withDrawGender: '1',
    dailyWithdrawLimit: 0,
    earningSlabs: [],
  })

  useEffect(() => {
    getConfiguration()
  }, [])

  const handleChange = (event: any) => {
    const {name, type, checked, value} = event.target
    const newValue = type === 'checkbox' ? checked : value

    setWithdrawalConfig({...withdrawalConfig, [name]: newValue})

    if (type === 'checkbox' || name === 'withDrawGender') {
      updateConfiguration({...withdrawalConfig, [name]: newValue})
    }
  }

  const getConfiguration = async () => {
    let result = await getConfigurationByName('withdraw')
    if (result.success) {
      let parsedData = JSON.parse(result.data.values)
      setConfigId(result.data.id)
      setWithdrawalConfig({
        isWithdraw: parsedData.isWithdraw,
        withDrawMinLimit: parsedData.withDrawMinLimit,
        withDrawDiamonds: parsedData.withDrawDiamonds,
        withDrawGender: parsedData.withDrawGender,
        dailyWithdrawLimit: parsedData.dailyWithdrawLimit || 0,
        earningSlabs: parsedData.earningSlabs || [],
      })
    }
  }

  const onBlurUpdate = () => {
    updateConfiguration(withdrawalConfig)
  }

  const updateConfiguration = async (config: any) => {
    let result = await updateConfigurationByConfigID(configID, config, null)
    if (result.success) {
      getConfiguration()
      ToastUtils({type: 'success', message: 'Configuration Saved SuccessFully'})
    } else {
      ErrorToastUtils()
    }
  }

  const addSlab = () => {
    const newSlabs = [...(withdrawalConfig.earningSlabs || []), { minEarning: 0, withDrawMinLimit: 0 }]
    const newConfig = { ...withdrawalConfig, earningSlabs: newSlabs }
    setWithdrawalConfig(newConfig)
  }

  const removeSlab = (index: number) => {
    const newSlabs = [...withdrawalConfig.earningSlabs]
    newSlabs.splice(index, 1)
    const newConfig = { ...withdrawalConfig, earningSlabs: newSlabs }
    setWithdrawalConfig(newConfig)
    updateConfiguration(newConfig)
  }

  const handleSlabChange = (index: number, field: string, value: any) => {
    const newSlabs = [...withdrawalConfig.earningSlabs]
    newSlabs[index] = { ...newSlabs[index], [field]: value }
    const newConfig = { ...withdrawalConfig, earningSlabs: newSlabs }
    setWithdrawalConfig(newConfig)
  }

  const handleSlabBlur = () => {
    updateConfiguration(withdrawalConfig)
  }

  return (
    <div className='card'>
      <div className='card-title p-8'>
        <h2>WithDrawal settings</h2>
      </div>
      <div className='card-body'>
        <div className='row no-gutters'>
          <div className='col-lg-4 card-body bg-light'>
            <p>
              <strong className='headings-color'>Withdrawal system</strong>
            </p>
            <p className='text-muted'>Allow users to exchange credits for real money</p>
          </div>
          <div className='col-lg-8 card-form__body card-body d-flex align-items-center bg-white'>
            <div className='form-check form-switch'>
              <input
                className='form-check-input'
                type='checkbox'
                role='switch'
                id='flexSwitchCheckDefault'
                name='isWithdraw'
                checked={withdrawalConfig.isWithdraw}
                onChange={(event) => {
                  setWithdrawalConfig({
                    ...withdrawalConfig,
                    [event.target.name]: event.target.checked,
                  })
                  updateConfiguration({
                    ...withdrawalConfig,
                    [event.target.name]: event.target.checked,
                  })
                }}
              />
            </div>
          </div>

          <div className='col-lg-4 card-body bg-light'>
            <p>
              <strong className='headings-color'>Withdrawal Diamonds</strong>
            </p>
            <p className='text-muted'>-</p>
          </div>
          <div className='col-lg-8 card-form__body card-body d-flex align-items-center bg-white'>
            <div className='flex'>
              <input
                type='number'
                className='form-control'
                name='withDrawDiamonds'
                value={withdrawalConfig.withDrawDiamonds}
                onChange={(event) => handleChange(event)}
                onBlur={onBlurUpdate}
              />
            </div>
          </div>

          <div className='col-lg-4 card-body bg-light'>
            <p>
              <strong className='headings-color'>Daily Withdrawal Limit Per User</strong>
            </p>
            <p className='text-muted'>Set to 0 for unlimited daily withdrawals</p>
          </div>
          <div className='col-lg-8 card-form__body card-body d-flex align-items-center bg-white'>
            <div className='flex'>
              <input
                type='number'
                className='form-control'
                name='dailyWithdrawLimit'
                value={withdrawalConfig.dailyWithdrawLimit}
                onChange={(event) => handleChange(event)}
                onBlur={onBlurUpdate}
              />
            </div>
          </div>

          <div className='col-lg-4 card-body bg-light'>
            <p>
              <strong className='headings-color'>Withdrawal Required Amount</strong>
            </p>
            <p className='text-muted'>Set the minimum amount of money to request a withdrawal</p>
          </div>
          <div className='col-lg-8 card-form__body card-body d-flex align-items-center bg-white'>
            <div className='flex'>
              <input
                type='number'
                className='form-control'
                name='withDrawMinLimit'
                value={withdrawalConfig.withDrawMinLimit}
                onChange={(event) => handleChange(event)}
                onBlur={onBlurUpdate}
              />
            </div>
          </div>

          <div className='col-lg-4 card-body bg-light'>
            <p>
              <strong className='headings-color'>Give Withdrawal Access to Selected Gender</strong>
            </p>
            <p className='text-muted'>-</p>
          </div>
          <div className='col-lg-8 card-form__body card-body d-flex align-items-center bg-white'>
            <div className='flex'>
              <select
                className='form-select form-select-solid fw-bolder'
                data-kt-select2='true'
                data-placeholder='Select option'
                data-allow-clear='true'
                data-kt-user-table-filter='gender'
                data-hide-search='true'
                defaultValue={withdrawalConfig.withDrawGender}
                name='withDrawGender'
                value={withdrawalConfig.withDrawGender}
                onChange={(event) => handleChange(event)}
                onBlur={onBlurUpdate}
              >
                <option value={'0'}>All Gender</option>
                <option value={'1'}>Male</option>
                <option value={'2'}>Female</option>
              </select>
            </div>
          </div>

        </div>

        <div className='row no-gutters mt-10 border-top pt-10'>
          <div className='col-lg-4 card-body bg-light'>
            <p>
              <strong className='headings-color'>Withdrawal Earning Slabs</strong>
            </p>
            <p className='text-muted'>Define dynamic minimum required amounts based on user's total past withdrawal earnings.</p>
            <button className='btn btn-primary btn-sm mt-3' onClick={addSlab}>Add Slab</button>
          </div>
          <div className='col-lg-8 card-form__body card-body bg-white'>
            {withdrawalConfig.earningSlabs && withdrawalConfig.earningSlabs.length > 0 ? (
              withdrawalConfig.earningSlabs.map((slab: any, index: number) => (
                <div key={index} className='d-flex align-items-center mb-4 gap-4'>
                  <div>
                    <label className='form-label small'>Min Earning (Rs)</label>
                    <input
                      type='number'
                      className='form-control form-control-sm'
                      value={slab.minEarning}
                      onChange={(e) => handleSlabChange(index, 'minEarning', e.target.value)}
                      onBlur={handleSlabBlur}
                    />
                  </div>
                  <div>
                    <label className='form-label small'>New Required Amount (Rs)</label>
                    <input
                      type='number'
                      className='form-control form-control-sm'
                      value={slab.withDrawMinLimit}
                      onChange={(e) => handleSlabChange(index, 'withDrawMinLimit', e.target.value)}
                      onBlur={handleSlabBlur}
                    />
                  </div>
                  <div className='mt-6'>
                    <button className='btn btn-danger btn-sm' onClick={() => removeSlab(index)}>Remove</button>
                  </div>
                </div>
              ))
            ) : (
              <p className='text-muted'>No slabs defined. Default configuration will be used for all users.</p>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default WithDrawalPlugin
